<template>
    <div class="cont">
        <div class="add-email">
            <p>{{ $t('通知联系人') }}</p>
            <div @click="isShow = true">
                <img src="../../assets/img/icons/addEmail.png">
                <span>{{ $t('添加') }}</span>
            </div>
          <div @click="addressBookFlag = true">
            <img src="../../assets/img/icons/addEmail.png">
            <span>{{ $t('通讯录') }}</span>
          </div>
        </div>
        <div class="email-wrap" v-for="(item, index) in state.emailList">
            <p class="title">{{ $t('受邀人') }}</p>
			<div class="nameTagRowPc">
				<span class="name">{{ item.name }}</span>
				<span class="tag">{{ item.label }}</span>
			</div>
            <div class="txt margintop0">
                <p>
                    <span>{{ $t('邮件地址') }}：</span>
                    <span>{{ item.email }}</span>
                </p>
                <div class="delete" @click="deleteEmail(index)">{{ $t('删除') }}</div>
            </div>
        </div>
    </div>

    <Transition name="fade">
        <div class="cont" v-show="isShow">
            <div class="email-wrap">
                <p class="title">{{ $t('受邀人') }}</p>
				<!-- 新增人名 标签 -->
				<div class="nameTagInputRow">
					<div class="nameBox">
						<common-input :name="$t('联系人')" v-model="name"></common-input>
					</div>
					<div class="tagSelectBox">
						<common-select :name="$t('标签')" :options="labelList" v-model="labelIndex"></common-select>
					</div>
				</div>
				<!-- 新增人名 标签End -->
                <div class="txt">
                    <div>
                        <input v-model="emailAddress" type="email" :placeholder="$t('请输入邮箱地址')" >
                    </div>
                    <div class="confirm" @click="pushEmail">{{ $t('确认') }}</div>
                </div>
            </div>
        </div>
    </Transition>

  <el-dialog v-model="addressBookFlag" class="newStyleDialog" :title="$t('通讯录')" :width="getWidth()">
	  <div class="searchRow">
		  <input v-model="searchValue" type="text" :placeholder="$t('姓名/标签/手机号')" />
		  <div class="searchBtn" @click="searchData()">{{ $t('搜索') }}</div>
	  </div>
    <el-table :data="addressBookFilterList" el-table-column @selection-change="handleSelectionChange" height="400px">
      <el-table-column type="selection" width="30" />
      <el-table-column :label="$t('姓名')" align="center" prop="name" width="80"/>
      <el-table-column :label="$t('邮箱')" align="center" prop="email" width="180"/>
	  <el-table-column :label="$t('标签')" align="center">
	    <template #default="scope">
	      <el-tag
	          type="warning"
	          disable-transitions
	          v-for="item1 in scope.row.label.split(',')"
	      >{{ item1 }}
	      </el-tag>
	    </template>


	  </el-table-column>
      <el-table-column :label="$t('手机号')" align="center" prop="mobile" width="180"/>
      <el-table-column :label="$t('SIP号')" align="center" prop="sip" width="180"/>
      <el-table-column :label="$t('与真号码(VMR)')" align="center" prop="vmr" width="180"/>
<!--      <el-table-column :label="$t('标签')" :filters="[-->
<!--        { text: 'Home', value: 'Home' },-->
<!--        { text: 'Office', value: 'Office' },-->
<!--      ]" align="center" prop="label" width="180">-->
<!--        <template #default="scope">-->
<!--          <el-tag-->
<!--              type="success"-->
<!--              disable-transitions-->
<!--              v-for="item1 in scope.row.label.split(',')"-->
<!--          >{{ item1 }}-->
<!--          </el-tag>-->
<!--        </template>-->

<!--      </el-table-column>-->
      <!-- <el-table-column align="right">
        <template #header>
          <el-input v-model="search" size="small" :placeholder="$t('标签搜索')" />
        </template>
        <template #default="scope">
          <el-tag
              type="success"
              disable-transitions
              v-for="item1 in scope.row.label.split(',')"
          >{{ item1 }}
          </el-tag>
        </template>


      </el-table-column> -->

<!--      <el-table-column :label="$t('备注')" align="center" prop="remark" width="180" />-->
    </el-table>

	<!-- 新增移动端样式 -->
	<div class="cardListBox">
		<div class="cardContainer" v-for="(item,index) in addressBookFilterList" @click="handleSelection(item,index)">
			<div class="nameTagRow">
				<img src="../../assets/img/icons/icon-rectangle.png" class="rectangle" alt="" />
				<div class="name">{{ item.name }}</div>
				<div class="tag">{{ item.label }}</div>
				<div class="item" :class="{ active: state.addressBookId.includes(item.id) }"> <!--选中样式active-->
				  <span class="cir"></span>
				</div>
			</div>
			<div class="infoSection">
				<div class="row">
					<span class="lable">{{ $t('邮箱：') }}</span>
					<span class="txt">{{ item.email }}</span>
				</div>
<!--				<div class="row">-->
<!--					<span class="lable">手机号：</span>-->
<!--					<span class="txt">13122332233</span>-->
<!--				</div>-->
			</div>
		</div>

	</div>

	<!-- 新增移动端样式 -->


    <!-- 分页组件 -->
	<div class="pageBox">
<!--		<div class="item"> &lt;!&ndash;选中样式active&ndash;&gt;-->
<!--		  <span class="cir"></span>-->
<!--		  <span class="txt">全选</span>-->
<!--		</div>-->

    <el-pagination
        v-model:current-page="bookPage.pageNo"
        :page-size="bookPage.pageSize"
        :small="false"
        :disabled="false"
        :background="false"
        layout="total, prev, pager, next"
        :total="state.total"
        @current-change="getAddress()"
    />
	</div>

    <div slot="footer" class="btnMarginTop" style="text-align:center">
      <el-button type="primary" @click="submitAddress">{{ $t('确定') }}</el-button>
      <el-button @click="addressBookFlag = false">{{ $t('取消') }}</el-button>
    </div>

  </el-dialog>
</template>

<script setup>
import {getCurrentInstance, onMounted, reactive, ref, watch, computed, onBeforeUnmount} from 'vue';
import {ElMessage} from "element-plus";
import {getAddressBookPage} from "@/api/yuzhen/addressBook";

// 多语言调用
const { appContext : { config: { globalProperties } } } = getCurrentInstance();
const labelList = [
    {
      id: 10,
      txt: "请选择"
    },
    {
			id: 11,
			txt: "同事"
		},
		{
			id: 12,
			txt: "朋友"
		},
  {
    id: 13,
    txt: "客户"
  },
  {
    id: 14,
    txt: "同学"
  },
  {
    id: 15,
    txt: "其他"
  },
	]
//添加邮箱显示隐藏
const isShow = ref(false);
// 改变传值
const emit = defineEmits(['changeEmail'])

// 弹窗的是否展示
const addressBookFlag = ref(false)
const search = ref('')
const searchValue = ref('')
const props = defineProps({
  data: { type: Array, default: [] },
})
const state = reactive({
  emailList: props.data,
  addressBookList: [],
  // 总条数
  total: 0,
  selectAddressBooks: [],
  addressBookId: [],
})

// 标签搜索
const addressBookFilterList = computed(() =>
    state.addressBookList.filter(
        (data) =>
            !searchValue.value ||
            data.label.toLowerCase().includes(searchValue.value.toLowerCase()) ||
            data.name.toLowerCase().includes(searchValue.value.toLowerCase()) ||
            data.mobile.toLowerCase().includes(searchValue.value.toLowerCase())
    )
)

// 搜索
function searchData(){
  // addressBookFilterList = state.addressBookList.filter(
  //     (data) =>
  //         data.label.toLowerCase().includes(searchValue.value.toLowerCase()) ||
  //             data.name.toLowerCase().includes(searchValue.value.toLowerCase()) ||
  //                 data.mobile.toLowerCase().includes(searchValue.value.toLowerCase())
  // )
}

// 选择触发
function handleSelectionChange(value) {
  state.selectAddressBooks = value
}

// 手机端选择触发
function handleSelection(value,index){

  if(state.addressBookId.includes(value.id)){
    const indexOf = state.addressBookId.indexOf(value.id);
    if (indexOf !== -1) {
      state.addressBookId.splice(indexOf, 1);
    }
    // 删除对应数据
    const indexOf1 = state.selectAddressBooks.indexOf(value);
    if (indexOf1 !== -1) {
      state.selectAddressBooks.splice(indexOf1, 1);
    }


  }else {
    state.addressBookId.push(value.id)
    state.selectAddressBooks.push(value)
  }
}

function submitAddress(){
  let reg = /^.+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
   if(state.selectAddressBooks.length > 0){
     let emailList = []
     state.emailList.forEach(item => {
       emailList.push(item.email)
     })
     state.selectAddressBooks.forEach(item => {
       // 没有包含则添加
       if(!emailList.includes(item.email) && reg.test(item.email)){
         state.emailList.push(item)
       }
     })
   }
  emit('changeEmail', state.emailList)
  addressBookFlag.value = false
}

function getWidth(){
  if(window.screen.width > 750){
    return '63%';
  }else {
    return '90%'
  }
}


//添加邮箱地址
const emailAddress = ref("");
const name = ref("");
const label = ref("");
const labelIndex = ref(10)

function pushEmail() {
  if(name.value == ""){
    ElMessage({
      type: 'error',
      message: globalProperties.$t('请输入联系人'),
    })
    return
  }
  if(labelIndex.value == 10){
    ElMessage({
      type: 'error',
      message: globalProperties.$t('请选择标签'),
    })
    return
  }
  let reg = /^.+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
  if (!reg.test(emailAddress.value)) {
    ElMessage({
      type: 'error',
      message: globalProperties.$t('邮箱格式错误'),
    })
    return
  }
  labelList.forEach(item => {
    if(item.id == labelIndex.value){
      label.value = item.txt;
    }
  })
  state.emailList.push({
    email: emailAddress.value,
    name: name.value,
    label: label.value,
  })
  emit('changeEmail', state.emailList)
  emailAddress.value = ""
  name.value = ""
  label.value = ""
  isShow.value = false
}

//删除邮箱
function deleteEmail(index) {
    state.emailList.splice(index, 1)
    emit('changeEmail',state.emailList)
}

// 通讯录分页查询
const bookPage = reactive({
  pageNo: 1,
  pageSize: 10,
})
function getAddress(){
  var query = {
    pageNo: bookPage.pageNo,
    pageSize: bookPage.pageSize,
    status: 0
  }
  getAddressBookPage(query).then(res => {
    state.addressBookList = res.data.list
    state.total = res.data.total;
  }).catch(err => {
    console.log(err)
  })
}

onMounted(() => {
  getAddress()
})

onBeforeUnmount(() => {
  // 清除数据
  state.emailList.splice(0)
})
</script>

<style src="./addEmail.css" scoped></style>
